import React, { memo } from "react";
import { TbGiftFilled } from "react-icons/tb";
import Media from "react-media";
import { RaisedButton } from "../../../components";
import useModal from "../../../hooks/useModal";
import { ReferAFriend } from "./ReferAFriend";
import { useFreeTrialAvailable } from "../../premium/hooks";
import NotificationBadge from "../../../components/NotificationBadge";

export default function WinPremiumButton() {
  const { data: trial } = useFreeTrialAvailable("30-day");

  const canRedeem = trial?.available;

  const [ReferralModal, setReferralModal] = useModal(
    {
      size: "lg",
      title: "",
      ReactComponent: () => (
        <ReferAFriend onClose={() => setReferralModal(false)} />
      ),
      hasBackButton: false,
    },
    []
  );
  const NotificationBadgeView = memo(() => {
    return canRedeem ? <NotificationBadge placement="left" /> : null;
  });

  return (
    <>
      <ReferralModal />

      <Media queries={{ small: { maxWidth: 480 } }}>
        {(matches) =>
          matches.small ? (
            <>
              <RaisedButton
                gap={"xs"}
                fontSize={"smaller"}
                aria-label="Win Premium"
                variation={"primary"}
                backgroundColor={"orange.60"}
                onClick={() => setReferralModal(true)}
                data-attr="earn-tokens-btn"
                data-ph-capture-attribute-type={"library"}
                position={"relative"}
              >
                <NotificationBadgeView />
                <TbGiftFilled fontSize={"larger"} />
              </RaisedButton>
            </>
          ) : (
            <>
              <RaisedButton
                gap={"xs"}
                fontSize={"smaller"}
                variation={"primary"}
                backgroundColor={"orange.60"}
                onClick={() => setReferralModal(true)}
                data-attr="earn-tokens-btn"
                data-ph-capture-attribute-type={"library"}
                position={"relative"}
              >
                <NotificationBadgeView />
                <TbGiftFilled fontSize={"larger"} />
                Win Premium
              </RaisedButton>
            </>
          )
        }
      </Media>
    </>
  );
}
